var _linearGradient, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDai24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0.5,
    x2: 0.5,
    y1: 1.142,
    y2: -0.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcc5f"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "url(#a)",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m159.262 162.331h-1.371a5.543 5.543 0 0 0 -5.461-3.531h-4.4v3.531h-1.53v1.269h1.529v1.329h-1.529v1.267h1.529v3.489h4.4a5.561 5.561 0 0 0 5.434-3.489h1.4v-1.267h-1.09a5.749 5.749 0 0 0 .042-.686v-.031c0-.208-.012-.412-.031-.612h1.082v-1.267zm-10-2.4h3.169a4.322 4.322 0 0 1 4.1 2.4h-7.267zm3.169 8.615h-3.169v-2.356h7.259a4.326 4.326 0 0 1 -4.09 2.353zm4.51-4.275a4.555 4.555 0 0 1 -.046.655h-7.633v-1.329h7.638a5.007 5.007 0 0 1 .042.643z",
    fill: "#fff",
    transform: "translate(-140.412 -152.238)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDai24);
export default __webpack_public_path__ + "static/media/ic_dai_24.bafa9da6971f783d400da68876210602.svg";
export { ForwardRef as ReactComponent };